// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"b829d560","213":"f5e34908","455":"08da01f5","726":"816655bb","806":"256d86c8"}[chunkId] + ".chunk.js";
};